import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Params, Resolve, RouterStateSnapshot} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';

// import {ApiService} from '@shared/services';
// import {TournamentModel} from '@shared/models';
import {TournamentModel} from 'shared/models';

@Injectable({providedIn: 'root'})
export class TournamentResolver implements Resolve<TournamentModel> {

  constructor(private http: HttpClient) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<TournamentModel> | TournamentModel {
    return this.http.get(`tournaments/${route.paramMap.get('tournamentId')}`)
      .pipe(
        map((data: Params) => {
          return TournamentModel.getInstance(data);
        })
      );
  }
}
